import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'percentageChange',
})
export class PercentageChangePipe implements PipeTransform {
    transform(current: number, previous: number): number {
        const value = previous ? ((current - previous) / previous) * 100 : 0;
        return Math.round(value);
    }
}
